// --------------------存储加购来源--------------------
$(document).on('click', '.product-block .product-link', function() {
  var page = LS.site.page;
  if (page == 'index') {
    var moduleType = $('.product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle').attr('block-title');
    window.localStorage.setItem('HDAddbagSource', 'collection-' + moduleType);
  }
  else if (page == 'collection') {
    window.localStorage.setItem('HDAddbagSource', 'collection');
  }
  else if (page == 'search') {
    window.localStorage.setItem('HDAddbagSource', 'search');
  }
  else if (page == 'cart') {
    window.localStorage.setItem('HDAddbagSource', 'bought-together-Bought Together');
  }
  else if (page == 'product') {
    var moduleType = $('.product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle').attr('block-title');
    if (moduleType == 'Bought Together') {
      window.localStorage.setItem('HDAddbagSource', 'bought-together-Bought Together');
    }
    else {
      window.localStorage.setItem('HDAddbagSource', 'also_like');
    }
  }
});

$(document).on('click', '#rk-widget-207144 .rktheme-product-image-wrap',function() {
  window.localStorage.setItem('HDAddbagSource', 'also_like');
});

/* -------------------------------------------订阅弹框--------------------------------------- */
function explodSubscribeWindow() {
  LS.stat({
    eid: 'Explod_SubscribeWindow',
    ext1: document.referrer
  });
}

function clickSubscribeIcon(status) {
  LS.stat({
    eid: status ? 'Click_SubscribeIcon' : 'explod_subscribe_edit',
    ext1: document.referrer,
    ext2: status ? 'code' : 'edit'
  });
}

function closeSubscribeIcon() {
  LS.stat({
    eid: 'Close_SubscribeIcon',
    ext1: document.referrer
  });
}

function subscribeSuccess() {
  LS.stat({
    eid: 'Click_SubscribeSignup',
    ext1: document.referrer,
    ext2: 'result_success'
  });
}

if (location.href.search('challenge') != -1) {
  LS.stat({
    eid: 'Explod_Robot',
    ext1: document.referrer
  });
}

// 点击商详主图图片
$(document).on('click', '#shopify-section-popup .cc-popup-form-buttons', function() {
  
  LS.stat({
    eid: 'Click_SubscribeSignup',
    ext1: document.referrer,
    ext2: 'click',
    ext3: document.querySelector('#shopify-section-popup .cc-popup-form__input-wrapper input').value
  });
});

/* -----------------------------------------首页rowbox商品曝光------------------------------------- */
function reportRowboxProducts() {
  let haveSeeShopIndexList = [];
  let products = $('.h-featured-list-rowbox .product-list').find(".product-block");
  let blockWidth = $('.h-featured-list-rowbox .collection-listing').width();
  if (window.screen.width > 768) {
    var scrollIndex = 1;
    $(document).on('click', '.h-featured-list-rowbox .collection-listing .sy-right-icon', function() {
      scrollIndex++;
      if (scrollIndex > 3) {
        return;
      }
      rowboxExposure(blockWidth * scrollIndex);
    });

    rowboxExposure(blockWidth);  
  }
  else {
    var stage = document.querySelector('.h-featured-list-rowbox .collection-listing');
    stage.addEventListener('touchend', function() {
      var carousel = $('.collection-listing .owl-carousel .owl-stage');
      rowboxExposure(blockWidth + carousel.scrollLeft());
    });

    rowboxExposure(blockWidth);
  }

  function rowboxExposure(maxWidth) {
    var list = [];
    $.each(products, function(index, item) {
      let shopIndex = index + 1;
      if (item.offsetWidth * shopIndex < maxWidth && haveSeeShopIndexList.indexOf(shopIndex) == -1) {
        // 记录当前已经预览过的商品index
        haveSeeShopIndexList.push(shopIndex); 
    
        // 获取商品信息
        let shopInfoData = {};
        // 获取基础参数
        let eventInfo = {};
        // 赋值商品信息
        shopInfoData.product_title = $(item).find('.h-product-block__title').text();
        shopInfoData.product_id = $(item).attr('data-product-id');
        shopInfoData.sort_number = shopIndex;

        eventInfo.eid = "product_explode";
        eventInfo.ext4 = 'module=collection-Best Seller';
        eventInfo.ext1 = 'title=' + shopInfoData.product_title;
        eventInfo.ext2 = 'pid=' + shopInfoData.product_id;
        eventInfo.ext3 = 'pos=' + shopIndex;
        // 添加进上报数组
        list.push(eventInfo);
      }
    });

    // 数据上报（列表曝光）
    if (list.length > 0) {
      LS.stat(list);
    }
  }
}

/* -----------------------------------------公用的商品集合滚动曝光方法------------------------------------- */
function commonProductListScrollHandle(typeStatus) {
  $(document).ready(function () { 
    // 定义一个数组，记录当前已经看过的商品索引，不重复上报
    let haveSeeShopIndexList = [];
    // 监听滚动停止
    let beforeScrollTop = 0;
    let afterScrollTop = 0;
    let timer = null; // 定时器
    let rowboxRet = true;
    // 曝光
    sendExposure();
    // 滚动
    window.addEventListener("scroll", function(e){
      // 清除定时器
      clearTimeout(timer);
      // 200ms一次监听,曝光
      timer = setTimeout(sendExposure, 200);
      // 赋值定时前的滚动高度
      beforeScrollTop =  $(window).scrollTop();
    });
    
    // 列表页商品曝光
    function sendExposure() {
      // 商品集合(根据类型取不同的class，来获取商品集合)
      let products;
      var page = LS.site.page;
      if (typeStatus == 'widget-alsolike') {
        products = $('.rktheme-grid').find("li");
      }
      else {
        if (page == 'index') {
          products = $(".h-featured-list-columnbox .product-list").find(".product-block");
        }
        else {
          products = $(".product-list").find(".product-block");
        }
      }
      // 滚动的高度+视图高度-100(商品模块展示程度需>=1/2,所以这里减去大概半个商品高度)
      let viewPortHeight = $(window).scrollTop()+$(window).height()-100;

      if (page == 'index') {
        var rowBoxHeight = $('.h-featured-list-rowbox .collection-listing').offset().top;
        if (rowBoxHeight && rowBoxHeight < viewPortHeight && rowboxRet) {
          rowboxRet = false;
          reportRowboxProducts();
          return;
        }
      }
      // 赋值定时后的滚动高度
      afterScrollTop = $(window).scrollTop();
      // 遍历商品集合
      var list = [];
      $.each(products, function(index,item) {
        // 集合商品距离
        let shopTop = 0;
        if (page == 'index' && window.screen.width > 768) {
          shopTop = item.offsetTop + $('.h-featured-list-columnbox .collection-listing').offset().top - 150;
        }
        else {
          shopTop = item.offsetTop;
        }
        // 索引位置
        let shopIndex = index + 1;
        // 判断是否在可视区域(商品顶部距离不为0 && 商品距离顶部距离 < 滚动的高度+视图高度 && 该商品ID未记录到已看数组里)
        if(shopTop && shopTop < viewPortHeight && haveSeeShopIndexList.indexOf(shopIndex) == -1){
          // console.log('test*********', shopTop, viewPortHeight, shopIndex, $(item).find(".product-block__title").text());
          // 当滚动停止200ms时
          if(afterScrollTop == beforeScrollTop){
            // 清除定时器
            clearTimeout(timer);
            // console.log("滚动停止", shopTop, viewPortHeight) // 这里处理
            // 判断商品距离顶部的距离 > 赋值定时后的滚动高度
            if ( shopTop > afterScrollTop ) {
              // 记录当前已经预览过的商品index
              haveSeeShopIndexList.push(shopIndex); 
              // console.log('test++++++++', shopTop, viewPortHeight, shopIndex, haveSeeShopIndexList, $(item).find(".product-block__title").text());
            
              // -----------接口曝光区域------------
              // 获取商品信息
              let shopInfoData = {};
              // 获取基础参数
              let eventInfo = {};
              // 赋值商品信息
              shopInfoData.product_title = typeStatus == 'widget-alsolike' ? $(item).find('.rktheme-product-title').text() : $(item).find('.h-product-block__title').text();
              shopInfoData.product_id = typeStatus == 'widget-alsolike' ? $(item).children('.rktheme-product-card').attr('data-rk-product-id') : $(item).attr('data-product-id');
              shopInfoData.sort_number = shopIndex;

              eventInfo.eid = "product_explode";
              // 赋值基础参数(根据类型取不同的事件id)
              if (typeStatus == 'widget-alsolike') {
                // 商品详情页插件的alsoLike
                eventInfo.ext4 = 'module=also_like';
              }
              else if (typeStatus == 'custom-alsolike') {
                // 商品详情页自定义的alsoLike
                eventInfo.aid = $(item).attr('data-product-aid');
                eventInfo.ext4 = 'module=also_like';
              } 
              else if (typeStatus == 'cartBoughtTogether') {
                // 购物车页的Bought Together
                eventInfo.ext4 = 'module=bought-together';
              } else {
                shopIndex = 1;
                // collection页商品列表
                eventInfo.ext4 = 'module=collection';
              }
              eventInfo.ext1 = 'title=' + shopInfoData.product_title;
              eventInfo.ext2 = 'pid=' + shopInfoData.product_id;
              eventInfo.ext3 = 'pos=' + shopIndex;
              // 添加进上报数组
              list.push(eventInfo);
            }
          }
        }
      })
      // 数据上报（列表曝光）
      if (list.length > 0) {
        LS.stat(list);
      }
    }
  });
}

/* -------------------------------------------首页相关--------------------------------------- */
// 判断是首页就触发此函数
if(LS.site.page == 'index'){
  homepageClick();
}

// 首页方法
function homepageClick() {
  // 主页曝光
  LS.stat({
    eid: 'exposure',
    ext1: document.referrer
  });

  // 主页banner->点击并跳转(至collection)
  $(document).on('click', '.text-column__image', function() {
    LS.stat({
      eid: 'clc_to_collection',
      ext1: $(this).find('a').attr("href"),
      ext2: 'banner'
    });
  });

  // 主页商品展开->点击More Details
  $(document).on('click', '.sy-more-detail-click', function() {
    LS.stat({
      eid: 'clc_to_products',
      ext1: $(this).attr("href"),
      ext2: $(".product-form").attr('data-product-id'),
      ext3: 'clc_details',
      ext6: '-1'
    });
  });

  // 主页点击品牌banner
  $(document).on('click', '.image-overlay__image-link', function() {
    LS.stat({
      eid: 'clc_brand_banner',
      ext1: $(this).attr("href")
    });
  });


  setTimeout(() => {
    commonProductListScrollHandle('trending-now');
  }, 1 * 500);
}

/* header事件,start ----- */
// 点击搜索
$('.show-search-link').click(function() {
  LS.stat({
    eid: 'clc_search',
    ext1: $(this).attr("href")
  });
});

// 点击购物车
// $('.cart-link').click(function() {
//   LS.stat({
//     eid: 'clc_menu_my_bag',
//     ext1: $(this).attr("href")
//   });
// });

// 点击menu按钮
$('.logo-area__left__inner button').click(function() {
  LS.stat({
    eid: 'clc_menu_entry'
  });
});

// 点击submenu
$(document).on('click', '.nav-children-li-item', function() {
  LS.stat({
    eid: 'clc_to_collection',
    ext1: $(this).children('a').attr("href"),
    ext2: 'submenu'
  });
});

// 点击home menu
$(document).on('click', '.h-custom-navbox-libox', function() {
  var text = $(this).find('p').text();
  var eventData = {};
  if (text == 'MY BAG') {
    eventData.eid = 'clc_menu_my_bag';
    eventData.ext1 = '/cart';
  }
  else if (text == 'MY ORDERS') {
    eventData.eid = 'clc_menu_my_orders';
    eventData.ext1 = $('.h-custom-navbox-ul').find('a:eq(2)').attr('href');
  }
  else if (text == 'MY ACCOUNT') {
    eventData.eid = 'clc_menu_my_account';
    eventData.ext1 = $('.h-custom-navbox-ul').find('a:eq(3)').attr('href');
  }
  else if (text == 'NEED HELP？') {
    eventData.eid = 'clc_menu_need_help';
    eventData.ext1 = '/pages/help-support';
  }
  else if (text == 'CONTACT US') {
    eventData.eid = 'clc_menu_about_us';
    eventData.ext1 = '/pages/about-us';
  }
  else {

  }
  LS.stat(eventData);
});

// 点击展开子菜单
$(document).on('click', '.mobile-select-box', function() {
  var text = $(this).children('a').text();
  var eventData = {};
  if (text == 'PICK A STYLE') {
    eventData.eid = 'clc_menu_pick_style';
  }
  else if (text == 'TOPS') {
    eventData.eid = 'clc_menu_top';
  }
  else if (text == 'BOTTOMS') {
    eventData.eid = 'clc_menu_bottom';
  }
  LS.stat(eventData);
});

/* header事件,start ----- */

// ----------------------------------------------account订单页面曝光-----------------------------------
if(location.pathname.includes("/account")){
  $(document).on('click','.h-account-order-id-click',function(){
    var eventData = {};
    eventData.eid = 'clc_order_deatil';
    eventData.ext1 = $(this).find('a').attr("href");
    eventData.ext2 = $(this).find('a').attr("orderId");
    LS.stat(eventData);
  });
}


// -----------------------------------------------商品详情曝光------------------------------------------
if(LS.site.page == 'product'){
  var indexList = new Array();
  var eventData = {};
  // 当获取到商品ID时进行页面曝光（解决上报提出未获取ID的情况）
  if ($(".product-form").attr('data-product-id')) {
    eventData.eid = 'exposure';
    eventData.ext1 = document.referrer;
    eventData.page_url = window.location.href;
    eventData.ext2 = $(".current-price").text();
    eventData.ext3 = $(".title-row .title").text();
    eventData.ext4 = 'pid=' + $(".product-form").attr('data-product-id');
    // products页曝光
    LS.stat(eventData);

    // 延时曝光第一张主图
    setTimeout(function() {
      indexList.push('1');
      eventData.eid = 'ExplodPic';
      eventData.ext1 = '1';
      LS.stat(eventData);
    }, 1 * 1000);
  }

  // 主图曝光
  $(document).on('touchend','.product-slideshow',function(){
    let index = $(this).find('.slick-current .h-product-slideshow-banner-num span').text();
    let str = String(index);
    if (indexList.indexOf(str) > -1) {
      return;
    }
    indexList.push(str);
    LS.stat({
      eid: 'ExplodPic',
      ext1: str
    });
  });
  $(document).on('touchend','.previewImage-box .previewImage-item',function(){
    let index = $('.previewImage-text').find('.previewImage-text-index').text();
    let str = String(index);
    if (indexList.indexOf(str) > -1) {
      return;
    }
    indexList.push(str);
    LS.stat({
      eid: 'ExplodPic',
      ext1: str
    });
  });
  $(document).on('click', '.product-detail .thumbnails .h-rimage-outer-wrapper-box', function() {
    let index = $('.h-product-detail-slideshow-web .slick-current .h-product-slideshow-banner-num span').text();
    let str = String(index);
    if (indexList.indexOf(str) > -1) {
      return;
    }
    indexList.push(str);
    LS.stat({
      eid: 'ExplodPic',
      ext1: str
    });
  });
}

// 点击并跳转(至collection)
$(document).on('click', '.navigation_homepageHeaderClick', function() {
  let link_url = $(this).attr('href');
  if (link_url.search("collections") == -1) {
    return;
  }
  LS.stat({
    eid: 'clc_to_collection',
    ext1: link_url,
    ext2: 'menu'
  });
});

// 插件alsolike点击添加购物车
$(document).on('change', '.rktheme-addtocart-select',function() {
  // 加购商品index位置
  var alsolike_cart_click_index = $(this).parents('.rktheme-grid-item').index()+1;
  // eventData.ext1 = $(this).parents('.rktheme-grid-item').find('.rktheme-product-image-wrap').attr("href");
  
  var result = {};
  result.product_id = $(this).parents('.rktheme-grid-item').find('.rktheme-product-card').attr('data-rk-product-id');
  result.sku_id = $(this).val();

  var eventData = {};
  eventData.eid = 'add_to_bag';
  eventData.ext1 = document.referrer;
  eventData.ext2 = JSON.stringify(result);
  eventData.ext3 = 'add_other';
  // 加购类型:1 - 详情页直接加购，2 - 列表弹窗加购，3 - 插件Also Like加购，4 - 详情页弹窗加购
  eventData.ext4 = '3';
  // 结果：op=ok:成功, op=no_size:尺码缺失, op=other:其他错误
  eventData.ext5 = 'op=ok';
  // 加购坑位(列表页传数字、详情页传-1）
  eventData.ext6 = 'pos=' + JSON.stringify(alsolike_cart_click_index);
  eventData.ext7 = 'module=also_like';
  let sourceType = window.localStorage.getItem('HDAddbagSource');
  if (sourceType) {
    eventData.ext8 = 'src=' + sourceType;
  }
  else {
    eventData.ext8 = 'src=none';
  }
  LS.stat(eventData);
});

// ---------------------------1202新增埋点-------------------------------
// 点击商详主图图片
$(document).on('click','.h-main-product .slick-slide',function(){
  let index =  Number($(this).attr('data-slick-index'));

  LS.stat({
    eid: 'ClickPic',
    ext1: String(index+1),
  });

});

// 点击选择颜色（底部colorSizeDataReportHandle方法）

// 点击选择尺码（底部colorSizeDataReportHandle方法）

// 点击动态结算按钮
$(document).on('click','.shopify-payment-button',function(){
  var payment_btn_type = $('.shopify-payment-button .shopify-payment-button__button').find('div').length;
  var eventData = {};
  // 判断点击的是buy it now还是其他支付方式

  if (payment_btn_type > 0) {
    // 点击BuyWithPaypal
    eventData.eid = 'ClickBuyWithPaypal';
    eventData.ext1 = 'Success';
  } else {
    // 点击BuyItNow
    eventData.eid = 'ClickBuyItNow';
    eventData.ext1 = 'Success';
  }
  LS.stat(eventData);
});

// 点击COPY
$(document).on('click','.h-coupon-list-box .box-copy-btn',function(){
  LS.stat({
    eid: 'ClcCopy',
    ext1: 'Success'
  });
});

// 点击查看物流政策
$(document).on('click','.sy-product-free-box .sy-product-free-shipping',function(){
  LS.stat({
    eid: 'ClickDeliveryViewMore'
  });
});

// 点击查看售后政策
$(document).on('click','.sy-product-free-box .sy-product-free-return',function(){
  LS.stat({
    eid: 'ClickReturn&RefundViewMore'
  });
});


// 尺码表切换
$(document).on('click','.model-table .tab',function(){
  LS.stat({
    eid: 'ClickIn'
  });
});

// 点击Size Guide
$(document).on('click','.sizing-help',function(){
  LS.stat({
    eid: 'Click_SizeGuide'
  });
});

/* --------------------------------------------Also Like相关--------------------------------------- */
// 查看商品详情
$(document).on('click','.rktheme-product-image-wrap,.rktheme-product-title',function(){
  var alsolike_cart_click_productId = $(this).parents('.rktheme-grid-item').find('.rktheme-product-card').attr('data-rk-product-id');
  // 加购商品index位置
  var alsolike_cart_click_index = $(this).parents('.rktheme-grid-item').index()+1;
  var result = {};
  var eventData = {};
  result.product_id = alsolike_cart_click_productId;
  result.sort_number = alsolike_cart_click_index;

  eventData.eid = 'clc_to_products';

  eventData.ext1 = 'title=' + $(this).parents('.rktheme-grid-item').find('.rktheme-product-image-wrap').attr("href");
  eventData.ext2 = 'pid=' + result.product_id;
  eventData.ext3 = 'clc_picture';
  eventData.ext4 = 'pos=' + JSON.stringify(result.sort_number);
  eventData.ext5 = 'module=also_like';

  LS.stat(eventData);
});

function customAlsolikeProduct(productId, aid, title, index) {
  var eventData = {};
  eventData.eid = 'clc_to_products';
  eventData.aid = aid;
  eventData.ext1 = 'title=' + title;
  eventData.ext2 = 'pid=' + productId;
  eventData.ext3 = 'clc_picture';
  eventData.ext4 = 'pos=' + index;
  eventData.ext5 = 'module=also_like';
  LS.stat(eventData);
}

// 自研alsolike添加购物车
function customAlsolikeAddbag(params) {
  var eventData = {};
  eventData.eid = 'add_to_bag';
  eventData.aid = choiceSkuPopView.productAid;
  eventData.ext1 = document.referrer;           //上一个页面url
  eventData.ext2 = JSON.stringify(params);    //jsonData
  eventData.ext3 = 'add_other';                 
  eventData.ext4 = '2'; // 加购类型:1 - 详情页直接加购，2 - 列表弹窗加购，3 - 插件Also Like加购，4 - 详情页弹窗加购
  eventData.ext5 = 'op=ok';
  eventData.ext6 = 'pos=' + choiceSkuPopView.index; //坑位
  eventData.ext7 = 'module=also_like';          //模块
  let sourceType = window.localStorage.getItem('HDAddbagSource');
  if (sourceType) {
    eventData.ext8 = 'src=' + sourceType;       //来源
  }
  else {
    eventData.ext8 = 'src=none';
  }
  LS.stat(eventData);
}

// 点击选择颜色尺码方法（theme.js）
function colorSizeDataReportHandle(value, label) {
  var eid = '';
  if (label === 'color') {
    eid = 'ClickColor';
  } else if (label === 'size') {
    eid = 'ClickSize';
  }

  eid && LS.stat({
    eid: eid,
    ext1: value
  });
}

// 抽屉曝光方法(component-cart-drawer.js)
function cartDrawerDataReportHandle() {
  LS.stat({
    eid: 'DrawerIn',
    ext1: 'pid=' + $(".product-form").attr('data-product-id')
  });
}

// 详情页-点击打开加购弹窗-上报
function report_product_detail_open_pop() {
  LS.stat({
    eid: 'Explod_BagWindow',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页-点击关闭加购弹窗-上报
function report_product_detail_close_pop() {
  LS.stat({
    eid: 'Out_BagWindow',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页点击size_guide上报
function detail_click_size_guide() {
  LS.stat({
    eid: 'click_size_guide',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页点击product_details上报
function detail_click_product_details() {
  LS.stat({
    eid: 'click_product_details',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页点击material&care上报
function detail_click_material_care() {
  LS.stat({
    eid: 'click_material_care',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页打开size_guide弹窗上报
function detail_open_size_guide() {
  LS.stat({
    eid: 'explod_size_guide',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页打开product_details弹窗上报
function detail_open_product_details() {
  LS.stat({
    eid: 'explod_product_details',
    ext2: $(".product-form").attr('data-product-id')
  });
}

// 详情页打开material&care弹窗上报
function detail_open_material_care() {
  LS.stat({
    eid: 'explod_material_care',
    ext2: $(".product-form").attr('data-product-id')
  });
}

/* ---------------------------------------------main-collection相关--------------------------------------- */
// 判断是列表collections页面，执行下面方法
if(LS.site.page == 'collection'){
  mainCollectionClick(true)
}

// -----------列表页商品点击--------------
$(document).on('click', '.product-list .product-block .h-rimage-outer-wrapper-box', function() {
  // 获取点击的ID以及位置
  let coll_click_title = $(this).parents('.product-block').find('.h-product-block__title').text();
  let coll_click_id = $(this).parents('.product-block').attr('data-product-id');
  let coll_click_index = $(this).parents('.product-block').index()+1;
  var eventData = {};
  eventData.eid = 'clc_to_products';
  eventData.ext1 = 'title=' + coll_click_title;
  eventData.ext2 = 'pid=' + coll_click_id;
  eventData.ext3 = 'clc_details';
  eventData.ext4 = 'pos=' + JSON.stringify(coll_click_index);
  LS.stat(eventData);
});

function mainCollectionClick(collectionStatus) {
  var eventData = {};
  // -----------列表页商品曝光--------------
  // 公用的商品集合滚动曝光方法
  commonProductListScrollHandle();

  // -----------列表页排序点击--------------
  $(document).on('click', '.sy-collection-sort .sy-collection-sort_item a', function() {
    LS.stat({
      eid: 'clc_sort',
      ext1: $(this).text()
    });
  })

  // -----------列表页点击顶部的tag--------------
  $(document).on('click', '.sy-filter-sub-tags', function() {
    
    eventData.ext1 = $(this).children('a').text();
    collectionReport('clc_tag');

    let currentUrl = window.location.href;
    var handel = $(this).attr('data-handle');
    let tag = $(this).find("a").attr('value');
    if (tag) {
        var lastStr = '';
        // 判断是否有筛选条件
        if (currentUrl.search("sort_by") != -1) {
            // 截取末尾的筛选条件
            lastStr = currentUrl.substring(currentUrl.lastIndexOf('?'));
        }
        // 判断当前url是否包含该标签
        if (currentUrl.search(tag) != -1) {
            location.href = LS.site.dir + '/collections/' + handel + lastStr;
        }
        else {
            location.href = LS.site.dir + '/collections/' + handel + '/' + tag;
        }
    }
    else {
        location.href = LS.site.dir + '/collections/' + handel;
    }
  })

  // collections页曝光
  eventData.eid = 'exposure';
  eventData.ext1 = document.referrer;
  eventData.page_url = window.location.href;
  if (collectionStatus == true) {
    LS.stat(eventData);
  }
  
  // 从collection点击至collection-phone
  $(document).on('click', '.nav-children-li-item', function() {
    eventData.ext1 = $(this).children('a').attr("href");
    collectionReport('clc_to_collection');
  });

  // 从collection点击至collection-web
  $(document).on('click', '.btn--tertiary', function() {
    eventData.ext1 = $(this).attr("href");
    collectionReport('clc_to_collection');
  });
  
  // 从collection点击筛选
  $(document).on('click', '.link-dropdown__options', function() {
    eventData.ext1 = $(this).children('a').attr("href");
    collectionReport('clc_to_collection');
  });

  // 点击滚到顶部
  $('#scroll-to-top').click(function() {
    collectionReport('clc_goto_top');
  });

  // 点击筛选按钮
  $(document).on('click', '.boost-pfs-filter-tree-mobile-button button', function() {
    collectionReport('clc_filter');
  });

  function collectionReport(event_id) {
    eventData.eid = event_id;
    LS.stat(eventData);
  }
}

/* -----------------------------------------搜索页曝光------------------------------------- */
if (LS.site.page == 'search') {
  LS.stat({
    eid: 'exposure',
    ext1: document.referrer
  });

  setTimeout(() => {
    commonProductListScrollHandle('search-collection');
  }, 1 * 500);
}



/* 点击more detal */
$(document).on('click','.sy-more-detail-click',function() {
  var eventData = {};
  eventData.eid = 'clc_to_products';
  eventData.ext1 = $(this).attr("href");
  eventData.ext2 = $(".product-form").attr('data-product-id');
  eventData.ext3 = 'clc_details';
  eventData.ext6 = '-1';
  LS.stat(eventData);
});

/* 点击到主页 */
$(document).on('click','.logo-area__middle__inner',function() {
  LS.stat({
    eid: 'clc_to_homepage',
    ext1: $(this).find('a').attr("href")
  });
});

/* 点击'ADD TO BAG' 和 BUY IT NOW  以及 Checkout*/
// 获取页面商品的json信息
let thisProductData = this.productJSON;

// 点击'ADD TO BAG'[选中尺码的情况]
$(document).on('click', '#btn--addToCart',function() {
  // 选中尺码的情况
  if (choiceSkuPopView.alsolikeStatus) {
    // also like弹窗加购
    choiceSkuPopView.alsolikeStatus = false;
    // var selector = document.querySelector('#_choiceSkuPopView-container .buy-buttons-row .original-selector');
    // var skuId = selector.options[selector.selectedIndex].value;
    customAlsolikeAddbag(choiceSkuPopView.dataJson);
  }
  else {
    add_to_bag_handle(true, this);
  }
});


/* 完善扩充参数 */
function getCommonParams(productJson) {
  var data = {};
  if (productJson) {
    data.id = productJson.id;
    data.title = productJson.title;
    data.price = productJson.price/100;
    data.size =  $("#clickyboxes-SingleOptionSelector-1").find(".active").text();
    data.color = $("#clickyboxes-SingleOptionSelector-0").find(".active").text();
    data.quantity = $(".quantity-wrapper").children("#quantity").val();
  }
  else {
    data.id = $(".product-form").attr('data-product-id');
    data.title = $(".title-row").find('a').text();
  }
  var list = new Array(data);
  var result = {};
  result.products = list;
  return JSON.stringify(result);
}

// 点击'ADD TO BAG'方法[选中尺码或者未选中尺码]
function add_to_bag_handle(status, thisObj) {
  var page = LS.site.page;
  let that = thisObj;
  // 判断不在详情页加购获取不到thisProductData的情况下，在attr上获取productData商品信息参数
  let attrProductData = $(that).attr('productData');
  let getThisShopData = thisProductData ? thisProductData : (attrProductData ? JSON.parse(attrProductData) : '');
  // 加购商品index位置
  let add_cart_click_index = $(that).parents('.product-block').index()+1 ? $(that).parents('.product-block').index()+1 : $(that).parents('.sy-product-choosesku-pop').index()+1;
  // 加购类型:1 - 详情页直接加购，2 - 列表弹窗加购，3 - 插件Also Like加购，4-详情页弹窗加购
  let addType,moduleType;
  let sourceType = window.localStorage.getItem('HDAddbagSource');
  if (page == 'index') {
    moduleType = choiceSkuPopView.moduleType;
    addType = '2';
  } 
  else if (page == 'product') {
    moduleType = 'other';
    addType = '1';
    if (choiceSkuPopView.moduleType == 'also_like') {
      moduleType = 'also_like';
      addType = '2';
    }
    else {
      let markSource = $(that).attr('markSource');
      if (markSource == 'productDetailAddbagPopup') {
        addType = '4';
      }
      else if (markSource == 'addbagPopup') {
        addType = '2';
        moduleType = 'Bought Together';
      }
    }
  } 
  else if (page == 'collection') {
    moduleType = 'other';
    addType = '2';
  } 
  else if(page == 'cart') {
    moduleType = 'bought-together-Bought Together';
    addType = '2';
  }
   else {
    moduleType = 'other';
    addType = '2';
  }

  var eventData = {};
  eventData.eid = 'add_to_bag';
  eventData.ext1 = document.referrer;
  eventData.ext3 = getThisShopData ? 'add_self' : 'add_other';
  eventData.ext4 = addType;
  // 结果：ok:成功, no_size:尺码缺失, other:其他错误
  eventData.ext5 = 'op=' + (status ? 'ok' : 'no_size');
  // 加购坑位(列表页传数字、详情页传-1）
  eventData.ext6 = 'pos=' + (add_cart_click_index ? JSON.stringify(add_cart_click_index) : '-1');
  eventData.ext7 = 'module=' + moduleType;
  if (sourceType) {
    eventData.ext8 = 'src=' + sourceType;
  }
  else {
    eventData.ext8 = 'src=none'
  }
  eventData.ext2 = getCommonParams(getThisShopData);
  LS.stat(eventData);
}

// 点击BUY IT NOW[选中尺码的情况]
$(document).on('click','.shopify-payment-button',function() {
  // 选中尺码的情况
  checkout_report_handle(true);

  setTimeout(() => {
    var eventData = {};
    eventData.eid = 'add_to_bag';
    eventData.ext1 = document.referrer;
    eventData.ext3 = thisProductData ? 'add_self' : 'add_other';
    eventData.ext4 = '1';
    // 结果：ok:成功, no_size:尺码缺失, other:其他错误
    eventData.ext5 = 'op=ok';
    // 加购坑位(列表页传数字、详情页传-1）
    eventData.ext6 = 'pos=-1';
    eventData.ext7 = 'module=other';
    let sourceType = window.localStorage.getItem('HDAddbagSource');
    if (sourceType) {
      eventData.ext8 = 'src=' + sourceType;
    }
    else {
      eventData.ext8 = 'src=none';
    }
    eventData.ext2 = getCommonParams(thisProductData);
    LS.stat(eventData);
  }, 500);
});

// 点击BUY IT NOW[选中尺码或者未选中尺码]
function checkout_report_handle(status) {
  var eventData = {};
  eventData.eid = 'checkout';
  eventData.ext3 = thisProductData ? 'checkout_buy_it_now' : 'checkout_other';
  // 结果：ok:成功, no_size:尺码缺失, other:其他错误
  eventData.ext4 = 'op=' + (status ? 'ok' : 'no_size');
  eventData.ext2 = getCommonParams(thisProductData);
  LS.stat(eventData);
}


// 阻止点击冒泡
$(document).on('click','.nav-children-ul',function(e){
  e.stopPropagation();
});


;(function() {
  try {
    var testCookie = LS.cookie.get('looksky-testcookie') || '';
    var testLocalStorage = localStorage.getItem('testLocalStorage') || '';
    var date = Date.now();
    if (testCookie || testLocalStorage) {
      var eventData = {};
      eventData.ext1 = testCookie + '';
      eventData.ext2 = testCookie ? (Date.now() - testCookie) + '' : '';
      eventData.ext3 = testLocalStorage + '';
      eventData.ext4 = testLocalStorage ? (Date.now() - testLocalStorage) + '' : '';
      eventData.eid = 'for_test';
      LS.stat(eventData);
    };
      if (!testCookie) {
        LS.cookie.set('looksky-testcookie', date, 24*30*12);
      }
      if(!testLocalStorage) {
        localStorage.setItem('testLocalStorage', date);
      }
     
  } catch(e) {
    window.imgReport({ page_url: window.location.href, eid: "js_error", ext1: e.message, ext2: 'custom-common', ext3: '-9'});
  }

})();